export default __webpack_public_path__ + "static/media/linux.6c13bb55.svg";